import { createContext, FC, useContext } from "react";
import { UseDisclosureProps } from "@chakra-ui/hooks";

const PackActionContext = createContext(null);

type PackActionContext = {
  deleteDialog: UseDisclosureProps;
  superpackModal: UseDisclosureProps;
  sharePackModal: UseDisclosureProps;
  movePackToSuperpack: (id: string) => Promise<void>;
  createSuperpackAndAddPack: (name: string) => Promise<void>;
}

export const PackActionProvider: FC<{ value: PackActionContext }> = ({ value, children }) => (
  <PackActionContext.Provider value={value}>
    {children}
  </PackActionContext.Provider>
);

export const usePackActionContext = () => useContext<PackActionContext>(PackActionContext);
